import React from "react";
import BasicModal from "../../../../Components/Modals/BasicModal";
import Btn from "../../../../Components/Buttons/Btn";
import { RiDeleteBin5Line } from "react-icons/ri";

const DeleteModal = ({
  showDeleteModal,
  setShowDeleteModal,
  handleDelete,
  systemId,
}) => {
  if (!showDeleteModal) return null;

  return (
    <BasicModal
      showModal={showDeleteModal}
      setShowModal={setShowDeleteModal}
      header="Delete Customer"
    >
      <div className="m-auto p-5">
        <h2 className="text-center text-red text-xl font-bold mb-6">
          Are you sure you want to delete this Customer?
        </h2>
        <div className="flex justify-between items-center">
          <Btn
            outline={true}
            btn="border"
            onClick={() => setShowDeleteModal(false)}
          >
            <p>Cancel</p>
          </Btn>
          <Btn
            outline={true}
            btn="border"
            onClick={() => handleDelete(systemId)}
          >
            <div className="flex justify-between items-center gap-x-2">
              <RiDeleteBin5Line className="text-red" />
              <p>Confirm</p>
            </div>
          </Btn>
        </div>
      </div>
    </BasicModal>
  );
};

export default DeleteModal;
